<template>
  <div id="components-layout-demo-basic" style="background: #ececec">
    <a-layout>
      <a-layout-header>课后服务开放平台</a-layout-header>
    </a-layout>
    <div v-if="show" class="page-border">
      <a-card :bordered="false" class="content-card">
        <p class="title">本系统<a v-if="isIE"
          target="_blank"
          href="https://learn.microsoft.com/zh-cn/lifecycle/announcements/internet-explorer-11-support-end-dates"
        >不支持IE浏览器</a><a v-if="isWX">不支持微信内置浏览器</a>打开，请尝试如下浏览器进行访问。</p>
        <p class="title">目标地址：{{ msg }}</p>
        <div class="line"></div>
        <div class="broswer">
          <a target="_blank" href="https://www.google.cn/chrome/">
            <img src="/icon/reg/chrome.jpg" alt="" class="img"
          /></a>
          <a
            target="_blank"
            href="https://www.mozilla.org/zh-CN/firefox/browsers/"
            ><img src="/icon/reg/firefox.png" alt="" class="img1"
          /></a>
          <a target="_blank" href="https://www.apple.com.cn/safari/">
            <img src="/icon/reg/safari.png" alt="" class="img1"
          /></a>
          <a target="_blank" href="https://www.microsoft.com/zh-cn/edge">
            <img src="/icon/reg/edge.jpg" alt="" class="img"
          /></a>
        </div>
      </a-card>
    </div>
  </div>
</template>

<script>
import chechEnv from '../../api/checkEnv';

export default {
  data() {
    return {
      msg:""
    }
  },
  computed: {
    isIE: function() {
      return navigator.userAgent.indexOf('Trident') > 0 ||
        navigator.userAgent.indexOf('MSIE') > 0;
    },
    isWX: function() {
      return navigator.userAgent.indexOf('MicroMessenger') > 0;
    },
    show: function() {
      return this.isIE || this.isWX;
    }

  },
  created() {
    let result = chechEnv.locationNextUrl(!this.show);
    if (result.returned) {
      return;
    }
    this.msg = result.target.replace(/\?.+/, "");
  }
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1280px) {
  div.page-border {
    padding-top: 108px;
    height: 100%;
  }
}

@media screen and  (max-width: 1280px) {
  div.page-border {
    padding-top: 28px;
    padding-right: 10px;
    padding-left: 10px;
    height: 100%;
  }  
}
div.page-border {
  background: #ececec;
}
.content-card {
  max-width: 1080px;
  min-width: 800px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

#components-layout-demo-basic {
  text-align: left;
  height: 100vh;
  overflow: auto;
  position: relative;
}
#components-layout-demo-basic .ant-layout-header {
  background: #0b0b0f;
  color: #ffffff;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  font-size: 24px;
}
.ant-card {
  margin-top: 100px;
  border-radius: 20px;
  padding: 30px;
  .title {
    display: block;
    font-size: 20px;
    color: #000;
    margin-bottom: 30px;
  }
  .line {
    width: 100%;
    height: 4px;
    background-color: rgba(235, 241, 253, 1);
  }
  .broswer {
    margin: 100px 0;
    width: 100%;
    display: flex;
    justify-content: space-around;
    .img1 {
      width: 152px;
    }
    .img {
      width: 150px;
    }
  }
}
</style>
